const constants = {
  showTopRatedContent: true,
  awardTypes: {
    isp: {
      label: 'Fastest Fixed Network',
      color: '#0FCBFF',
      visible: true
    },
    carrier: {
      label: 'Fastest Mobile Network',
      color: '#CC8CFF',
      visible: true
    },
    best: {
      label: 'Best Internet Provider',
      color: '#0FCBFF',
      visible: true
    },
    coverage: {
      label: 'Best Mobile Coverage',
      color: '#CC8CFF',
      visible: true
    },
    top_rated_carrier: {
      label: 'Top-Rated Mobile Network',
      color: '#CC8CFF',
      visible: true
    },
    top_rated_provider: {
      label: 'Top-Rated Fixed Network',
      color: '#CC8CFF',
      visible: true
    },
    best_mobile: {
      label: 'Best Mobile Network',
      color: '#CC8CFF',
      visible: true
    },
    '5g': {
      label: 'Fastest 5G Mobile Network',
      color: '#CC8CFF',
      visible: true
    },
    best_5g_gaming_experience: {
      label: 'Best 5G Gaming Experience',
      color: '#CC8CFF',
      visible: true
    },
    best_mobile_gaming_experience: {
      label: 'Best Mobile Gaming Experience',
      color: '#CC8CFF',
      visible: true // this will toggle the methodology links on that page for game score awards
    },
    best_isp_gaming_experience: {
      label: 'Best ISP Gaming Experience',
      color: '#CC8CFF',
      visible: true
    },
    '5g_video_experience': {
      label: 'Best 5G Video Experience',
      color: '#CC8CFF',
      visible: true
    },
    best_mobile_video_experience: {
      label: 'Best Mobile Video Experience',
      color: '#CC8CFF',
      visible: true
    },
    best_isp_video_experience: {
      label: 'Best ISP Video Experience',
      color: '#CC8CFF',
      visible: true
    },
    best_fixed: {
      label: 'Best Fixed Network',
      color: '#CC8CFF',
      visible: true
    },
    best_5g: {
      label: 'Best 5G Network',
      color: '#CC8CFF',
      visible: true
    }

  },
  awardTypeOrder: [],
  navigationGroups: { // based on locationName
    'World': true,
    regional: {
      'Central africa': true,
      'Caribbean': true,
      'Europe': true,
      'North America': true,
      'Western Africa': true,
      'South America': true,
      'Latin America': true,
      'Africa': true,
      'East Africa': true,
      'GCC': true,
      'Asia': true,
      'North Africa': true
    }
  },
  privacyPolicyNotice: {
    updated: '2020-09-01',
    dayThreshold: 3 * 30,
    cookie: 'privacy_notice_dismissed'
  },
  legacySiteURL: 'https://www.speedtest.net/legacy-awards',
  methodologyLink: '/awards/methodology',
  coverageLink: '/coverage',
  tooltips: {
    speedScore:
      'Speed Score is calculated using download speed value and upload speed value. Each value is determined using a modified trimean (see methodology for more).',
    coverageScore:
      'Coverage Score assesses the spatial extent to which a provider offers service. See methodology for details.',
    rating: 'The mean of all the user rating samples (see methodology for more).',
    videoScore: 'Video Score is a weighted sum of multiple video experience metrics aligned to a common 0-100 scale (see methodology for details).',
    gameScore: 'Game Score is a weighted sum of multiple metrics aligned to a common 0-100 scale. See Methodology for more details.',
    speedtestConnectivityScore: 'Speedtest Connectivity Score™ A combination of Speed Score (50%), Video Streaming Score (25%), and Web Browsing Score (25%) aligned to a common 0-100 scale.'
  },
  // will be rendered in the same order as defined here
  timePeriods: ['q1-q4', 'q3-q4', 'q2-q3', 'q1-q2'],
  timePeriodLabels: {
    'q1-q4': 'Q1-Q4',
    'q3-q4': 'Q3-Q4',
    'q2-q3': 'Q2-Q3',
    'q1-q2': 'Q1-Q2'
  },
  popularSearches: [
    {
      name: 'United States',
      icon: 'pin',
      route: '/united_states/'
    },
    {
      name: 'Iceland',
      icon: 'pin',
      route: '/iceland/'
    },
    {
      name: 'Canada',
      icon: 'pin',
      route: '/canada/'
    },
    {
      name: 'Vodafone',
      icon: 'company',
      route: '/vodafone/'
    },
    {
      name: 'XFINITY',
      icon: 'company',
      route: '/xfinity/'
    },
    {
      name: 'T-Mobile',
      icon: 'company',
      route: '/t-mobile/'
    }
  ]
};

// add award types to the order array if they are set to visible.
if (constants.awardTypes.carrier.visible) {
  constants.awardTypeOrder.push('carrier');
}
if (constants.awardTypes.isp.visible) {
  constants.awardTypeOrder.push('isp');
}
if (constants.awardTypes.coverage.visible) {
  constants.awardTypeOrder.push('coverage');
}
if (constants.awardTypes.best.visible) {
  constants.awardTypeOrder.push('best');
}
if (constants.awardTypes.best_mobile.visible) {
  constants.awardTypeOrder.push('best_mobile');
}
if (constants.awardTypes.top_rated_carrier.visible) {
  constants.awardTypeOrder.push('top_rated_carrier');
}
if (constants.awardTypes.top_rated_provider.visible) {
  constants.awardTypeOrder.push('top_rated_provider');
}
if (constants.awardTypes['5g'].visible) {
  constants.awardTypeOrder.push('5g');
}

if (constants.awardTypes['5g_video_experience']) {
  constants.awardTypeOrder.push('5g_video_experience');
}

if (constants.awardTypes.best_mobile_video_experience.visible) {
  constants.awardTypeOrder.push('best_mobile_video_experience');
}

if (constants.awardTypes.best_isp_video_experience.visible) {
  constants.awardTypeOrder.push('best_isp_video_experience');
}

if (constants.awardTypes.best_5g_gaming_experience.visible) {
  constants.awardTypeOrder.push('best_5g_gaming_experience');
}

if (constants.awardTypes.best_mobile_gaming_experience.visible) {
  constants.awardTypeOrder.push('best_mobile_gaming_experience');
}

if (constants.awardTypes.best_isp_gaming_experience.visible) {
  constants.awardTypeOrder.push('best_isp_gaming_experience');
}

if (constants.awardTypes.best_fixed.visible) {
  constants.awardTypeOrder.push('best_fixed');
}

if (constants.awardTypes.best_5g.visible) {
  constants.awardTypeOrder.push('best_5g');
}

export default constants;
